<!-- <div *ngIf="currentUser">
  <app-login-success></app-login-success>
</div>

<div class="main-content" *ngIf="!currentUser">
  <app-login></app-login>
</div> -->
<!-- <router-outlet></router-outlet> -->
<main *ngIf="updateCheckComplete && forceUpdateRequired" class="force-update-screen">
  <h1>Update required</h1>
  <p>{{ forceUpdateService.getMessage() }}</p>
  <button type="button" (click)="forceUpdateService.openStore()">Update app</button>
</main>

<ng-container *ngIf="updateCheckComplete && !forceUpdateRequired">
  <app-top-bar class="d-sm-block"></app-top-bar>
  <!--<mobile-navigator class="d-blcok d-sm-none"></mobile-navigator>-->
  <!--<app-bottom-container></app-bottom-container>-->
  <router-outlet></router-outlet>
  <!--<app-footer></app-footer>-->
</ng-container>
